import L from 'leaflet';

export default class MapCommon {
  // classes are still defined in LeafletMap component CSS
  public static agmIconOnline = L.divIcon({
    className: 'agmIconOnline',
    iconSize: [32, 32],
  });

  public static agmIconOffline = L.divIcon({
    className: 'agmIconOffline',
    iconSize: [32, 32],
  });

  public static agmIconOnlineIridium = L.divIcon({
    className: 'agmIconOnlineIridium',
    iconSize: [32, 32],
  });

  public static agmIconOfflineIridium = L.divIcon({
    className: 'agmIconOfflineIridium',
    iconSize: [32, 32],
  });

  public static unassignedIcon = L.divIcon({
    className: 'agmIconOfflinePigRun',
    iconSize: [32, 32],
  });

  public static assignedOnlineIcon = L.divIcon({
    className: 'agmIconAssignedPigRun',
    iconSize: [32, 32],
  });

  public static assignedOfflineIcon = L.divIcon({
    className: 'agmIconOfflinePigRun',
    iconSize: [32, 32],
  });

  public static assignedIridiumOnlineIcon = L.divIcon({
    className: 'agmIconAssignedPigRunIridium',
    iconSize: [32, 32],
  });

  public static assignedIridiumOfflineIcon = L.divIcon({
    className: 'agmIconOfflinePigRunIridium',
    iconSize: [32, 32],
  });

  // Icons for deviceType 'AGMVECTOR' (previously productNumber 62)
  public static agmIconOnline62 = L.divIcon({
    className: 'agmIconOnline62',
    iconSize: [32, 32],
  });

  public static agmIconOffline62 = L.divIcon({
    className: 'agmIconOffline62',
    iconSize: [32, 32],
  });

  public static agmIconOnlineIridium62 = L.divIcon({
    className: 'agmIconOnlineIridium62',
    iconSize: [32, 32],
  });

  public static agmIconOfflineIridium62 = L.divIcon({
    className: 'agmIconOfflineIridium62',
    iconSize: [32, 32],
  });

  public static assignedOnlineIcon62 = L.divIcon({
    className: 'agmIconAssignedPigRun62',
    iconSize: [32, 32],
  });

  public static assignedOfflineIcon62 = L.divIcon({
    className: 'agmIconOfflinePigRun62',
    iconSize: [32, 32],
  });

  public static assignedIridiumOnlineIcon62 = L.divIcon({
    className: 'agmIconAssignedPigRunIridium62',
    iconSize: [32, 32],
  });

  public static assignedIridiumOfflineIcon62 = L.divIcon({
    className: 'agmIconOfflinePigRunIridium62',
    iconSize: [32, 32],
  });
}
